import BasePolicy from '@/policies/BasePolicy.js';

export default class ActivityLogPolicy extends BasePolicy {
    view(user) {
        return false;
    }

    create(user) {
        return false;
    }

    update(user) {
        return false;
    }

    delete(user) {
        return false;
    }
}
